import gql from "graphql-tag";

export const GET_DISHES_PAGINATION_QUERY = gql`
  query GetDishesPagination(
    $skip: Int!
    $take: Int!
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getDishes(
      data: {
        orderBy: $orderBy
        pagination: { skip: $skip, take: $take }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        title
        unit
        description
        fromDate
        toDate
        fromTime
        toTime
        ingredients {
          ingredientId
          ingredient {
            id
            title
            unit
          }
          value
        }
      }
    }
  }
`;
